































import Vue from 'vue';
import FieldPhoto from '@/components/FieldPhoto.vue';
import FieldWashTagTime from '@/components/FieldWashTagTime.vue';
import validationMessages from '@/utils/validationMessages';
import { Validation } from 'vuelidate';

interface Validations {
  [key: string]: Validation;
}

export default Vue.extend({
  name: 'FieldWashTag',
  components: {
    FieldPhoto,
    FieldWashTagTime,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    v: {
      type: Object as () => Validations,
      default: Object as () => Validations,
    },
  },
  methods: {
    validationMessages,
  },
});
